import { ObjectKeysFromValues } from '@/types/utils';
import { Key_Role } from '@/graphql/codegen/gql/graphql';
import { Agent_SortOrder } from '@/graphql/codegen/generated/graphql';

export type KeysRoles = 'Grid Admin' | 'Group Manager' | 'Viewer';

export const HEADERS = [
  { minWidth: 224, name: 'API Key', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 224, name: 'Description', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 100, name: 'Created By', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 100, name: 'Role', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 100, name: 'Last Used', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 100, name: 'Valid Until', sortable: true, defaultSortOrder: Agent_SortOrder.Descending },
];

export const MAP_COLUMNS_To_Key_Roles: Record<KeysRoles, Key_Role> = {
  'Grid Admin': Key_Role.GridAdmin,
  'Group Manager': Key_Role.GroupManager,
  Viewer: Key_Role.Viewer,
};
export const MAP_Key_Roles_To_Show: Record<keyof ObjectKeysFromValues<typeof MAP_COLUMNS_To_Key_Roles>, keyof typeof MAP_COLUMNS_To_Key_Roles> = {
  [Key_Role.GridAdmin]: 'Grid Admin',
  [Key_Role.GroupManager]: 'Group Manager',
  [Key_Role.Viewer]: 'Viewer',
};
